/**
 * Created By xiyuan
 * Author server@xiyuan.name (惜缘叛逆)
 * DateTime 2018/12/25 14:17
 * Describe javascript功能
 * MIT License http://www.opensource.org/licenses/mit-license.php
 */

import Vue from 'vue'
import Vuex from 'vuex'
import { Toast, Dialog } from 'vant';
// 获取客户端ip
// import getIp from '@utils/net/ip';
// 购物车商品存储器
// import shoppingStore from '@store/shopcart/shopping';
// 时间处理
import date from '@utils/date'
import router from "../../router";
let vmVue = new Vue();
const $date = date.date;
let Router = router;

/**
 * 订单轨迹状态 (订单进度)
 0 - Submitted, 订单提交
 1 - Accepted,  接单       接单
 2 - Rejected,   拒接
 3 - Cancelled,   取消
 4 - Created,     制作     制作
 10 - Prepare,    预备     制作
 20 - Baking,     烘焙     进炉
 30 - Boxing,     装箱    质检
 40 - Delivering,  运输   派送
 50 - Delivered,   交货   完成
 99 - Unknown")   未知
 */
const progressList = [
  '接单',
  '制作',
  '进炉',
  '质检',
  '派送',
  '完成',
]
const askprogressList = progressList.concat();
askprogressList[4] = '完成';
askprogressList.pop();

// 订单提交数据
const orderPayInfoName = '__order_pay_info__'

// 订单信息仓库
const orderStore = new Vuex.Store({
  state: {
    progressList,
    askprogressList,
    payInfo: undefined,
  },
  getters: {
    // 是否支付中
    isInPay (state) {
      if (!state.payInfo) {
        state.payInfo = Vue.$localStore.get(orderPayInfoName);
      }
      return state.payInfo;
    }
  },
  mutations: {
    // 支付中
    inPay (state, orderInfo) {
      // 为了便于维护时候清楚内部结构
      orderInfo = {
        money: orderInfo.money,
        orderNo: orderInfo.orderNo,
        orderMethod: orderInfo.orderMethod,
        orderId: orderInfo.orderId,
        payInfo: orderInfo.payInfo,
      }
      state.payInfo = orderInfo;
      // 添加支付记录
      Vue.$localStore.set(orderPayInfoName, orderInfo, { exp: 60 * 30 });
    },
    // 支付结束
    endPay (state) {
      state.payInfo = undefined;
      // 移除支付记录
      Vue.$localStore.delete(orderPayInfoName);
    }
  },
  actions: {
    // 未支付的订单再次支付
    morePay ({ }, payItem) {
      //去支付
      let payInfo = {};
      //api地址
      let url;
      //判断是什么支付方式//0代表支付宝、1代表微信、2代表银联支付、3代表货到付款
      switch (Number(payItem.id)) {
        case 0:
          payInfo = {
            name: "支付宝",
            type: "zfb",
            value: {
              paySource: 1,
              payName: "支付宝",
              paymentType: 'pc'
            }
          };
          url = "alipayPCCreateOrder";
          break;
        case 1:
          payInfo = {
            name: "微信",
            type: "wx",
            value: {
              paySource: 2,
              payName: "微信",
              // paymentType: 'pc'
            }
          };
          url = "getPrepayInfoPC";
          break;
        case 2:
          payInfo = {
            name: "银联",
            type: "yl",
            value: {
              paySource: 3,
              payName: "银联",
              // paymentType: 'pc'
            }
          };
          url = "unionpayWebCreateOrder";
          break;
        case 3:
          payInfo = {
            name: "货到付款",
            type: "hdfk",
            value: {
              paySource: 3,
              payName: "货到付款",
              // paymentType: 'pc'
            }
          };
          url = "offlinePayment";
          break;
          case 23:
          payInfo = {
            name: "抖音支付",
            type: "lzf",
            value: {
              paySource: 23,
              payName: "抖音支付",
              // paymentType: 'pc'
            }
          };
          url = null;
        case 27:
          payInfo = {
            name: "龙支付",
            type: "lzf",
            value: {
              paySource: 27,
              payName: "龙支付",
              // paymentType: 'pc'
            }
          };
          url = null;
          break;
          case 28:
            payInfo = {
              name: "达美乐电子礼品卡+龙支付",
              type: "lzf",
              value: {
                paySource: 28,
                payName: "达美乐电子礼品卡+龙支付",
                // paymentType: 'pc'
              }
            };
            url = null;
            break;
            case 29:
          payInfo = {
            name: "达美乐电子预付卡+龙支付",
            type: "lzf",
            value: {
              paySource: 29,
              payName: "达美乐电子预付卡+龙支付",
              // paymentType: 'pc'
            }
          };
          url = null;
          break;
          case 30:
          payInfo = {
            name: "达美乐电子预付卡+达美乐电子礼品卡+龙支付",
            type: "lzf",
            value: {
              paySource: 30,
              payName: "达美乐电子预付卡+达美乐电子礼品卡+龙支付'",
              // paymentType: 'pc'
            }
          };
          url = null;
          break;
          case 31:
            payInfo = {
              name: "预付卡和抖音支付",
              type: "lzf",
              value: {
                paySource: 31,
                payName: "预付卡和抖音支付",
                // paymentType: 'pc'
              }
            };
            url = null;
            break;
        case 32:
          payInfo = {
            name: "礼品卡和抖音支付",
            type: "lzf",
            value: {
              paySource: 32,
              payName: "礼品卡和抖音支付",
              // paymentType: 'pc'
            }
          };
          url = null;
          break;
          case 33:
              payInfo = {
                name: "预付卡礼品卡和抖音支付",
                type: "lzf",
                value: {
                  paySource: 33,
                  payName: "预付卡礼品卡和抖音支付",
                  // paymentType: 'pc'
                }
              };
              url = null;
              break;
        default:
          payInfo = {
            name: "货到付款",
            type: "hdfk",
            value: {
              paySource: 4,
              payName: "货到付款",
              // paymentType: 'pc'
            }
          };
          url = "offlinePayment";

      };
      //当前订单的支付信息
      let payOrderInfo = payItem.info;
      //支付类型
      const payTypes = payInfo.value;
      //提交的数据
      const sendData = {
        payAmount: payOrderInfo.needPayAmount || payOrderInfo.orderAmountAfterActivity || payOrderInfo.orderAmount,
        orderNos: [payOrderInfo.orderNo],
        orderId: payOrderInfo.id

      }
      //判断是否来自status
      const FromStatusPages = payItem.fromStatus ? true : false;
      // 加载提示
      const toast = Toast.loading({
        mask: true,         // 是否显示背景蒙层
        duration: 0,        // 持续展示 toast
        forbidClick: true,  // 禁用背景点击
        loadingType: 'spinner',
        message: '加载中...'
      });

      return new Promise((resolve, reject) => {
        // 支付宝回跳路径
        sendData.frontUrl = window.location.href;
        sendData.alipayReturnUrl = window.location.protocol + '//' + window.location.host + '/status';// window.location.href;
        sendData.returnUrl = window.location.protocol + '//' + window.location.host + '/status';
      
        vmVue.$post(url, sendData).then(res => {
          if (res.data.errCode != '00') {
            toast.clear();
            if (res.data.errCode =='400505') {
              Dialog.alert({
                title: '',
                message: res.data.errMsg,
                confirmButtonText: '我知道了',
              })
              return;
            }
            return Toast(res.data.errMsg);
          }
          res = res.data.data;
          
          // 关闭之前的弹窗
          toast.clear();
        
          // 记录订单数据表示支付中
          orderStore.commit('inPay', {
            orderId: res.orderId || payOrderInfo.id,
            orderNo: res.orderNo || payOrderInfo.orderNo,
            payInfo: payTypes,
            money: sendData.payAmount
          });

          // 检查支付类型
          switch (payInfo.type) {
            case 'zfb':
              history.replaceState({}, "", "/status");
              // 此代码适用于支付宝支付呼起
              let div = document.createElement('div');
              div.innerHTML = res.html;
              div.style.display = 'none';
              document.body.appendChild(div);
              div.querySelector('form').submit();
              break;
            case 'wx':
              resolve(res);
              if (!payItem.IsWxPayPage) {
                Router.push(`/wxpay?orderId=${res.orderId || payOrderInfo.id}`);
              }
              break;
            case 'hdfk':
              // Router.push('/status');
              ////判断是否来自status,如果是则重新加载
              if (FromStatusPages) {
                window.location.reload();
              } else {
                Router.push('/status');
              }

              break;
            case 'yl':
              history.replaceState({}, "", "/status");
              // if(payItem.IsWxPayPage){
              // 	history.replaceState({}, "", "/status");
              // }else{
              // 	Router.push('/status');
              // }
              let html = res.unionPayParas;
              let yldiv = document.createElement('div');
              yldiv.innerHTML = res.unionPayParas;
              yldiv.style.display = 'none';
              document.body.appendChild(yldiv);
              yldiv.querySelector('form').submit();
              break;
          }

        }, errMsg => {
          // 关闭之前的弹窗
          toast.clear();
          reject(errMsg);
          Toast(errMsg);
        });
        // })

      })
    },
    // 再来一单
    oneMoreOrder ({ }, orderNo) {
      return new Promise((resolve, reject) => {
        Vue.$service('oneMoreOrder').success(res => {
          Router.push('/order/submit');
          resolve()
        }).error(err => {
          Toast(err)
          reject(err);
        }).send({
          orderNo
        })
      });
    },
    // 退款
    refund ({ }, orderId) {
      return new Promise((resolve, reject) => {
        vmVue.$post('refund', { orderPayNoId: orderId }).then(res => {
          // res={data:{
          // 	"errCode": "01",
          // 	"errMsg": "达美乐50",
          // 	"data": {
          // 	  "storeTel": "4001-597-597",
          // 	  "content": "达美乐50"
          // 	}
          //   }	}	
          //   			  
          if (res.data.errCode != '00') {
            if (res.data && res.data.data && res.data.data.content) {
              Dialog.alert({
                title: '',
                className: 'refundbyjiaohang',
                message: `<div><div class="titledl">退券失败，请联系客服<span class="storeTel">${res.data.data.storeTel ? res.data.data.storeTel : (res.data.data.standbyTel ? res.data.data.standbyTel : '4001-597-597')}</span></div><span class="qw">${res.data.data.content}</span></div>`,
                confirmButtonText: '我知道了',
              }).then(() => {
                resolve(res)
                // this.SubmitOrder();
              }).catch(() => {
                resolve(res)

              });
            } else {
              resolve(res)
              return Toast(res.data.errMsg)
            }

          } else {
            res = res.data.data;
            Toast('成功,请稍后查看');
            resolve(res);
          }
        }).catch(err => {
          Toast(err)
          reject(err);
        })
      });
    },
    //取消订单
    cancelOrder ({ }, orderId) {
      return new Promise((resolve, reject) => {
        vmVue.$post('cancelOrder', { orderPayNoId: orderId }).then(res => {
          if (res.data.errCode != '00') {
            if (res.data && res.data.data && res.data.data.content) {
              Dialog.alert({
                title: '',
                className: 'refundbyjiaohang',
                message: `<div><div class="titledl">退券失败，请联系客服<span class="storeTel">${res.data.data.storeTel ? res.data.data.storeTel : (res.data.data.standbyTel ? res.data.data.standbyTel : '4001-597-597')}</span></div><span class="qw">${res.data.data.content}</span></div>`,
                confirmButtonText: '我知道了',
              }).then(() => {
                resolve(res)
                // this.SubmitOrder();
              }).catch(() => {
                resolve(res)

              });
            } else {
              resolve(res)
              return Toast(res.data.errMsg)
            }

          } else {
            res = res.data.data;
            Toast('订单已取消');
            resolve(res);
          }
        }).catch(err => {
          Toast(err)
          reject(err);
        })
      });
    },
    // 订单类型或订单时间检查接口
    orderReservation ({ }, { orderTime, orderType, serviceMethod, storeCode }) {
      return new Promise((resolve, reject) => {
        const sendData = {
          orderTime: orderTime ? $date.convert(orderTime).getTime() : 0,
          serviceMethod: Number(orderType === undefined ? serviceMethod : orderType),
        };
        if (storeCode) sendData.storeCode = storeCode;
        // 触发规则检测
        Vue.$post('orderReservation', sendData).then(resolve).catch(reject);
        // 更新购物车订单类型
        // shoppingStore.commit('changeOrderType', orderType);
      })
    }
  }
})
  ;


// 订单轨迹状态转换成文字
orderStore.progressCover = function (code, ask, state, detailed) {
  let status = null;
  switch (code) {
    case 0:
      status = '待接单';
      //如果有门店订单号则视为已接单
      if (detailed && detailed.storeOrderId) {
        code = 1;
        status = '接单';
      }
      break;
    case 1:
      status = '接单';
      break;
    case 2:
      status = '拒接';
      break;
    case 3:
      status = '取消';
      break;
    case 4:
    case 10:
      status = '制作';
      break;
    case 20:
      status = '进炉';
      break;
    case 30:
      status = '质检';
      break;
    case 40:
      status = '派送';
      break;
    case 50:
      status = ask ? '完成' : '完成';
      break;
    case 99:
    default:
  }
  if (!state) return status || '未知';
  if (ask && code == 30) {
    status = '待外带';
  } else if (ask && code == 40) {
    status = '待' + status;
  } else if (code == 1) {
    status = '已' + status;
  } else if (code == 20) {
    status = '烘焙中';
  } else if (status) {
    status += '中';
  } else {
    status = '待接单';
  }
  // console.log(code+'code'+ask+'ask')
  // console.log(status+'status')
  return status;
}

// 订单轨迹状态转换成对应的时间
orderStore.progressCoverTime = function (state, orderTime, item) {
  // 接单
  let receiveTime = item.startTime;
  // 制作
  let makeTime = item.orderSaveTime;
  // 进炉
  let feedTime = item.orderLoadDate;
  // 质检
  let checkingTime = item.rackDate;
  // 派送
  let dispatchTime = item.dispatchTime;
  // 完成时间
  let successTime = item.driverReturnTime;
  switch (state) {
    case '订单提交':
    case '接单':
      return receiveTime
    // case '拒接':
    // case '取消':
    // case '制作':
    // 	return makeTime;
    // case '进炉':
    // 	return feedTime
    // case '质检':
    // 	return checkingTime
    case '派送':
      // case '外带':
      return dispatchTime
    case '完成':
    case '完成':
      return successTime
    case 99:
    default:
    // '未知';
  }
}
orderStore.orderStateMap = function (state) {
  // 0-未确认 1-已接受 2-已拒绝 3-已取消 4-支付失败 5-待支付 6-已支付 7-货到付款 8-已完成 9-已退款 10-未支付订单过期取消
  if (!state) {
    return '未知';
  }
  switch (state) {
    case 0:
      status = '未确认';
      break;
    case 1:
      status = '已接受';
      break;
    case 2:
    case 3:
    case 9:
    case 10:
      status = '已取消';
      break;
    case 4:
      status = '支付失败';
      break;
    case 5:
      status = '待支付';
      break;
    case 6:
      status = '已支付';
      break;
    case 7:
      status = '货到付款';
      break;
    case 8:
      status = '已完成';
      break;
  }
  return status;
}
//判断所选门店是否开业
orderStore.opening = function (store) {
  if (store.storeStatus == 0 || store.StoreStatus == 0) {
    return [false, store.StoreName || store.StoreNameCHN || store.storeName];
  } else {
    return [true, store.StoreName || store.StoreNameCHN || store.storeName];
  }
}

// 页面是否隐藏监听（处理支付后页面返回来后重定向到订单状态）
function pageVisibilityListener () {
  let hiddenProperty = 'hidden' in document ? 'hidden' :
    'webkitHidden' in document ? 'webkitHidden' :
      'mozHidden' in document ? 'mozHidden' :
        null;
  let visibilityChangeEvent = hiddenProperty.replace(/hidden/i, 'visibilitychange');
  // 监听页面是否隐藏 或显示
  document.addEventListener(visibilityChangeEvent, visibilityChangeEventFn);
}

function visibilityChangeEventFn () {
  if (!document[hiddenProperty]) {
    document.removeEventListener('visibilityChangeEvent', visibilityChangeEventFn)
    Router.push('/order/status')
  }
}

export default orderStore;